// extracted by mini-css-extract-plugin
export default {"wrapper":"Carousel_wrapper__OQwsm","tab":"Carousel_tab__Lob4R"};